import React from 'react'
import { sideNavAnalyticsProps } from '../side-nav-analytics-props'
import { useIsActive } from 'app/packs/src/utils/use-is-active'
import * as SideMenu from 'components/side-menu'
import { Tag } from 'src/design-system'
import { Flag } from '@phosphor-icons/react'
import { observer } from 'mobx-react-lite'
import { store } from 'store/index'

export const First90DaysLink = observer(() => {
  const path = '/first-90-days'
  const title = 'First 90 Days'

  const isActive = useIsActive(path)

  // Employee-only surface, shown only where an admin has switched it on for the
  // account. The page controller enforces the same rule for anyone who reaches
  // the URL directly.
  if (!store.currentUser?.org?.first90DaysEnabled) return null

  return (
    <SideMenu.LinkItem
      active={isActive}
      href={path}
      analyticsProps={sideNavAnalyticsProps({
        href: path,
        title,
      })}
      icon={Flag}
      data-element-id="side-nav-first-90-days-link"
    >
      {title}
      {/* Recently shipped, so it gets flagged until people have found it. */}
      <Tag className="ml-auto" variant="success">
        New
      </Tag>
    </SideMenu.LinkItem>
  )
})
